import Router, {Resource} from "tg-resources";
import getCookie from './utils/cookie';

const options = {
    headers: () => ({
        'X-CSRFToken': getCookie('csrftoken'),
        accept: 'application/json',
    }),
};

const api = new Router({
    createGame: new Resource('/api/v1/game/create/', options),
    players: new Resource('/api/v1/users/', options),
    searchCourses: new Resource('/api/v1/course/search/', options),
    course: new Resource('/api/v1/course/', options),
    searchUsers: new Resource('/api/v1/users/', options),
    gameInfo: new Resource('/api/v1/game_info/', options),
    results: new Resource('/api/v1/result/', options),
    finishGame: new Resource('/api/v1/game/finish/', options),
});

export default api;



// WEBPACK FOOTER //
// ./src/api.js